<template>
  <span class="d-inline-block ico-cat">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25.515 18.745">
      <path id="Path_5203" data-name="Path 5203" :style="`fill:${color}; fill-rule:evenodd;`" d="M25.515,8.25,14.291,0H0L25.515,18.745Z" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'AppCategory',
  props: ['color'],
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  }
}
</script>
